<div class="progress-bar">
  <div
    class="progress-bar--bar"
    [style.height.px]="barHeight"
    [style.background]="
      showDangerRange
        ? (barValue / barMaxValue) * 100 > dangerRange
          ? 'var(--danger)'
          : 'var(--ui-primary-default)'
        : 'var(--ui-primary-default)'
    "
    style.width="{{ (barValue / barMaxValue) * 100 }}%"
  ></div>
  <ng-container *ngIf="barValueToAdd > 0">
    <div
      class="progress-bar--under"
      [style.height.px]="barHeight"
      style.width="{{ (barValueToAdd / barMaxValue) * 100 }}%"
    ></div>
  </ng-container>
</div>
